const breederMatingListFilters = {
    state: {
      filters: {}
    },
    mutations: {
      // Mutation to set a filter based on the label
      setBreederMatingListFilters(state, { label, value }) {
        state.filters[label] = value;
      },
      resetBreederMatingListFilters(state) {
        state.filters = {};
      }
    },
    actions: {
      // Action to apply a filter
      applyBreederMatingListFilters({ commit }, { label, value }) {
        commit('setBreederMatingListFilters', { label, value });
      },
      resetBreederMatingListFilters({ commit }) {
        commit('resetBreederMatingListFilters');
      }
    },
    getters: {
      getBreederMatingListFilters: (state) => (label) => {
        return state.filters[label] || null;
      }
    }
  };
  
  export default breederMatingListFilters;
  